import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallHome/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/mallHome' // 道具商城/金币商城
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/mallDetail'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallList/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/mallList'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallSureOrder/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/sureOrder'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallOrderPaySuccess/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/orderPaySuccess'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallRecordList/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/recordList'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallCoupon/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/coupon'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallExpireCoupon/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/expireCoupon'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widgetMall/widgetMallCheckCoupon/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widgetMall/checkCoupon'
  }
]
